import React from 'react';

import styled from 'styled-components';

import { SendGift } from 'components/send-gift';
import { withAuthRequired } from 'pages/authentication/auth-required';

const SendGiftWrapper = styled.div`
  margin: 0 auto 2rem;
  max-width: ${Styles.layout.smallerSectionMaxWidth};
  ${Styles.desktop`
    margin-top: 110px; // Should not be HC
  `}
`;

const SendGiftPage = () => {
  return (
    <SendGiftWrapper data-testid="send-gift-page">
      <SendGift />
    </SendGiftWrapper>
  );
};

export default withAuthRequired(SendGiftPage);
